import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { AuthContext } from '../contexts/AuthContext';
import { LanguageContext } from '../contexts/LanguageProvider';

const translations = {
  pt: {
    text: 'Sair',
    title: 'Encerrar sessão',
    ariaLabel: 'Sair do sistema',
  },
  en: {
    text: 'Logout',
    title: 'End session',
    ariaLabel: 'Logout of the system',
  },
};

function LogoutButton({ text, variant = 'outline-light', className = '' }) {
  const navigate = useNavigate();
  const { setIsLoggedIn, setUsername, setRole } = useContext(AuthContext);
  const { language } = useContext(LanguageContext);

  const t = translations[language] || translations.pt;
  const buttonText = text || t.text;

  const handleLogout = () => {
    localStorage.removeItem('auth');
    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('username');
    setIsLoggedIn(false);
    setUsername('');
    setRole('');
    navigate('/');
  };

  return (
    <Button
      variant={variant}
      onClick={handleLogout}
      size="sm"
      className={`fw-bold d-inline-flex align-items-center justify-content-center gap-2 ${className}`}
      title={t.title}
      aria-label={t.ariaLabel}
    >
      <FaSignOutAlt />
      {buttonText}
    </Button>
  );
}

export default LogoutButton;
